
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M11.89 10.6c-1.634-.377-3.154-.708-2.418-2.1C11.714 4.264 10.067 2 7.7 2 5.286 2 3.679 4.351 5.927 8.5c.759 1.4-.819 1.729-2.418 2.1C2.095 10.922 2 11.614 2 12.811v.589h11.4v-.589c0-1.2-.095-1.888-1.51-2.215zm-.865 1.85H7.65v-1.62h3.375z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      